import React, {Fragment, useEffect, useState} from 'react';
import createForm from "./Form";
import Select from "../../form/Select";
import TextInput from "../../form/TextInput";
import DateTimeInput from "../../form/DateTimeInput";
import Shipping from "../../form/shipping/shipping";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import Button from "../../form/Button";
import {connect} from "src/store";
import {CurrencyFormatter, DateFormatter} from "../../../utils/formatters";
import CheckBox from "../../form/CheckBox";
import {postData} from "src/utils/request";
import Modal from "src/components/layout/Modal";
import Portal from "src/components/layout/Portal";

const ClerkInfo = (props) => {
    const [info, setInfo] = useState(null);
    const [opened, setOpened] = useState(false);
    useEffect(() => {
        let req = postData({
            action: props.values.serviceprovider_type + ".getClerkInfo",
            id: props.values.serviceprovider_id,
        });
        req.then((res) => {
            setInfo(res.data);
            setOpened(false);
        });
        return () => {
            req?.abort();
        }
    }, [props?.values?.[props.componentConfig.idfield]]);
    useEffect(() => {
        let req = postData({
            action: props.values.serviceprovider_type + ".getClerkInfo",
            id: props.values.serviceprovider_id,
        });
        req.then((res) => {
            setInfo(res.data);
            setOpened(false);
        });
        return () => {
            req?.abort();
        }
    }, []);
    return info?.shippingorder_id ? <div className="row form-row">
        <div className="col-md-12">
            <div className="form-group">
                {info.signature ? <Fragment>
                    <Portal>
                        <Modal
                            state={opened}
                            header="Aláírás"
                            size="medium"
                            buttons={[
                                {
                                    text: "Bezárás",
                                    props: {color: "default"},
                                    onClose: true,
                                    onClick: async () => {
                                        setOpened(false);
                                    }
                                }
                            ]}
                        >
                            <img className="img-responsive img-bordered-sm" alt={info.clerk} src={info.signature} />
                        </Modal>
                    </Portal>
                    <label className="control-label">Átvevő</label>
                    <div className="input-group">
                        <TextInput
                            label={false}
                            value={info.clerk}
                            disabled={true}
                        />
                        <div className="input-group-btn">
                            <Button
                                color="default"
                                onClick={() => setOpened(true)}
                                icon={{lib: "fas", name: "pencil-alt"}}
                                tooltip="Aláírás"
                            />
                        </div>
                    </div>
                </Fragment> : <TextInput
                    label="Átvette"
                    value={info.clerk}
                    disabled={true}
                />}
            </div>
        </div>
    </div> : null;
}

class shippingForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            autoFill: !this.props.values[this.props.componentConfig.idfield],
            expiresAt: this.props.values.expires_at
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({
                autoFill: !this.props.values[this.props.componentConfig.idfield],
                expiresAt: this.props.values.expires_at
            })
        }
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <Select
                                objectValue={true}
                                optionname="shippingstate"
                                storeType="local"
                                name="state"
                                value={ (this.props.values && this.props.values.state) || null }
                                label="Állapot"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("state")}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <TextInput
                                name="contact"
                                value={this.props.values.contact}
                                label="Név"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("contact")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <TextInput
                                name="telnum"
                                value={this.props.values.telnum}
                                label="Telefonszám"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("telnum")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <TextInput
                                name="email"
                                value={this.props.values.email}
                                label="Email"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("email")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="promised_shipping_date"
                                value={this.props.values.promised_shipping_date}
                                label="Ígért szállítási határidő"
                                saveChanges={this.props.setFieldValue}
                                formatter={DateFormatter}
                                {...this.props.getFieldProps("promised_shipping_date")}
                                disabled="disabled"
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="order_date"
                                value={this.props.values.order_date}
                                label="Szállítás megrendelés dátuma"
                                saveChanges={this.props.setFieldValue}
                                formatter={DateFormatter}
                                {...this.props.getFieldProps("order_date")}
                                disabled="disabled"
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                objectValue={false}
                                optionname="shippingprovider"
                                storeType="local"
                                name="serviceprovider_type"
                                value={(this.props.values && this.props.values.serviceprovider_type) || null}
                                label="Szállítás módja"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("serviceprovider_type")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                </div>
                {this.props.values.serviceprovider_type !== "external_shipping" && <div className="row form-row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <TextInput
                                name="tracking_id"
                                value={this.props.values.tracking_id}
                                label="Követési kód"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("tracking_id")}
                                disabled={this.props.getFieldProps("tracking_id").disabled || this.props.values.serviceprovider_type === "personalpickup"}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 currency">
                        <div className="form-group">
                            <TextInput
                                name="shipping_fee"
                                value={this.props.values.shipping_fee}
                                label="Szállítási díj"
                                formatter={CurrencyFormatter}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("shipping_fee")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("pickup_date")}
                                name="pickup_date"
                                value={this.props.values.pickup_date}
                                label="Felvétel időpontja"
                                showTime={true}
                                disabled={true}
                                saveChanges={ this.props.setFieldValue }
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("delivery_date")}
                                name="delivery_date"
                                value={this.props.values.delivery_date}
                                label="Kézbesítés időpontja"
                                showTime={true}
                                disabled={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>}
                {
                    this.props.values.serviceprovider_type === "personalpickup" && (this.props.values.state + "" === "2" ? <div className="row form-row">
                        <div className="col-md-10">
                            <DateTimeInput
                                name="expires_at"
                                value={this.state.expiresAt}
                                label="Lejárat"
                                showTime={false}
                                disabled={this.props.isLoading}
                                saveChanges={(field, expiresAt) => this.setState({expiresAt})}
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            <Button
                                block={true}
                                color="default"
                                disabled={this.props.isLoading || this.state.expiresAt === this.props.values.expires_at}
                                onClick={() => this.props.updateExpiresAt(this.state.expiresAt)}
                            >
                                Módosítás
                            </Button>
                        </div>
                    </div> : <div className="row form-row">
                        <div className="col-md-12">
                            <DateTimeInput
                                {...this.props.getFieldProps("expires_at")}
                                name="expires_at"
                                value={this.props.values.expires_at}
                                label="Lejárat"
                                showTime={true}
                                disabled={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>)
                }
                <div className="row form-row">
                    <Shipping
                        {...this.props}
                        client={this.props.businessComponent}
                        linkContact={this.props.values[this.props.componentConfig.idfield] ? false : this.state.autoFill}
                        {...this.props.getFieldProps("shipping")}
                        autoFill={this.props.values[this.props.componentConfig.idfield] ? false : this.state.autoFill}
                        getFieldProps={this.props.getFieldProps}
                        disabled={this.props.disabled}
                        value={this.props.values}
                        saveChanges={this.props.setFieldValue}
                    />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Dokumentumok</label>
                        <SelectorGrid
                            {...this.props.getFieldProps("labels")}
                            disabled={false}
                            className={"p-small-table"}
                            view={["filename", "path"]}
                            type={SelectorDocuments}
                            pageSize={0}
                            name={"labels"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            orderBy={{field: "filename", direction: "ASC"}}
                        />
                    </div>
                </div>
                {this.props.values.serviceprovider_type === "booklog_shipping" && <ClerkInfo {...this.props} />}
                {
                    this.props.values.serviceprovider_type === "personalpickup"
                    && this.props.values.cod_amount > 0
                    &&
                    <Fragment>
                        <div className="row form-row">
                            <div className="col-md-3 currency">
                                <TextInput
                                    name="cod_amount"
                                    value={this.props.values.cod_amount}
                                    formatter={CurrencyFormatter}
                                    label="Utánvét összege"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("cod_amount")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <TextInput
                                    name="cod_title"
                                    value={this.props.values.cod_title}
                                    label="Gyűjtő"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("cod_title")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-3">
                                <Select
                                    label="Pénztár"
                                    name="moneyrepository"
                                    component="MoneyRepository"
                                    options={this.props.till.moneyrepositories}
                                    objectValue={false}
                                    labelKey="paymentlabel"
                                    valueKey="repository_id"
                                    storeType="local"
                                    {...this.props.getFieldProps("moneyrepository")}
                                    value={this.props.moneyrepository}
                                    disabled={this.props.isLoading || this.props.values.state + "" === "3" || this.props.values.state + "" === "0"}
                                    saveChanges={(field, moneyrepository) => this.props.setMoneyRepository(moneyrepository)}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="control-label">&nbsp;</label>
                                <Button
                                    disabled={this.props.isLoading || !this.props.moneyrepository || this.props.values.state + "" === "3" || this.props.values.state + "" === "0"}
                                    color="primary"
                                    block={true}
                                    onClick={this.props.personalpickupCompleted}
                                >
                                    Átvette
                                </Button>
                            </div>
                        </div>
                    </Fragment>
                }
                {!this.props.values[this.props.componentConfig.idfield] && <Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <CheckBox value={this.state.autoFill} label="Automatikus adat kitöltés" saveChanges={(field, value) => {
                                this.setState({autoFill: !!value});
                            }} />
                        </div>
                    </div>
                </Fragment>}
            </form>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createForm(shippingForm));
